import { render, staticRenderFns } from "./ModalPiutang.vue?vue&type=template&id=13cb79d5"
import script from "./ModalPiutang.vue?vue&type=script&lang=js"
export * from "./ModalPiutang.vue?vue&type=script&lang=js"
import style0 from "./ModalPiutang.vue?vue&type=style&index=0&id=13cb79d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports